<div *ngIf="filters.length" class="filter-wrapper">
  <mat-form-field class="filter-select">
    <mat-label>{{ 'MY_FILTERS' | translate }}</mat-label>
    <mat-select [(ngModel)]="filterModel" (ngModelChange)="filterChange.emit($event)">
      <mat-option *ngFor="let filter of filters" [value]="filter.name">
        {{ filter.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <button mat-icon-button (click)="addFilter.emit()" [matTooltip]="'ADD' | translate">
      <mat-icon class="material-icons-outlined" fontIcon="library_add"></mat-icon>
    </button>
    <button [disabled]="!filterModel" mat-icon-button (click)="restoreFilter.emit()" [matTooltip]="'RESTORE' | translate">
      <mat-icon class="material-icons-outlined" fontIcon="restore"></mat-icon>
    </button>
    <button [disabled]="!filterModel" mat-icon-button (click)="updateFilter.emit()" [matTooltip]="'UPDATE' | translate">
      <mat-icon class="material-icons-outlined" fontIcon="save"></mat-icon>
    </button>
    <button [disabled]="!filterModel" mat-icon-button (click)="deleteFilter.emit()" [matTooltip]="'DELETE_FILTER' | translate">
      <mat-icon class="material-icons-outlined" fontIcon="delete"></mat-icon>
    </button>
  </div>
</div>